export default __webpack_public_path__ + "static/media/cat4.01f71757.png";